<template>
	<main>
		<p class="reactivate-contact-text">
			A contact with the same First Name, Last Name, and Email Address already
			existed in the past. Do you want to re-add this contact?
		</p>
		<OverviewModalFooter
			:success="false"
			:waiting="false"
			@handleClick="handleOK"
			@close="handleClose"
			:isSaveModal="true"
			primaryButtonName="Ok"
		/>
	</main>
</template>

<script>
import OverviewModalFooter from './OverviewModalFooter.vue';
import { VIEWS } from './constants';

export default {
	name: 'ReactivateSingleContact',
	components: { OverviewModalFooter },
	methods: {
		handleClose() {
			this.$emit('close');
		},
		handleOK() {
			this.$emit('reactivateSingleContact', VIEWS.HOME);
		},
	},
};
</script>

<style lang="scss" scoped>
.reactivate-contact-text {
	display: flex;
	align-items: center;
	@include rem('padding', 10px 20px);
}
</style>
